import { RoseTree } from '@tableau/data-structures';
import { NestedProjectBasicInfo } from '@tableau/nested-project-explorer';
import { GetWorkbooksRequest } from '../../ts/ServerApi/requests/GetWorkbooksRequest';
import WebHttpClient from '../../httpClient/WebHttpClient';

function isValidExtension(filename: string, validFileTypes: string[]): boolean {
    const fileExtension = getFileExtension(filename);
    return validFileTypes.includes(fileExtension);
}

function getFileExtension(filename: string): string {
  const indexOfExtension = filename.lastIndexOf('.');

  if (indexOfExtension < 0) {
    return '';
  } else {
    return filename.substring(indexOfExtension);
  }
}


function getFileNameOnly(filename: string): string {
  return filename.substring(0, filename.lastIndexOf('.'));
}

function getWorkbooksCall(workbookname: string, projectId: string) {
  return WebHttpClient.sendRequest(new GetWorkbooksRequest(getParams(workbookname, projectId)));
}


// Modified from https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
export function formatBytes(bytes: number, decimals = 1) {
  if (bytes === 0) return '0';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function getParams(workbookname: string, projectid: string): any {

  const params = {
    filter: {
      operator: 'and',
      clauses: [
        {
          operator: 'eq',
          field: 'name',
          value: workbookname
        },
        {
          operator: 'eq',
          field: 'projectId',
          value: projectid
        }
      ]
    }
  };

  return params;
}

export default {
  isValidExtension,
  getFileNameOnly,
  getWorkbooksCall,
  formatBytes,
  getFileExtension
};
